// ¿Ha visto ya esta cuenta las pantallas de bienvenida? (04/11/2026)
// Antes se guardaba por navegador ('level_onboarding_done'): una cuenta nueva
// en un móvil que ya había usado la app no las veía nunca (Guillermo). Ahora
// va por cuenta; la marca antigua solo cuenta para cuentas de más de 2 días,
// para no volver a enseñárselas a quien ya las vio.
const LEGACY = 'level_onboarding_done'
const key = (uid) => `${LEGACY}:${uid}`

export function onboardingDone(user) {
  try {
    if (!user?.id) return !!localStorage.getItem(LEGACY)
    if (localStorage.getItem(key(user.id))) return true
    const age = Date.now() - new Date(user.created_at || 0).getTime()
    return !!localStorage.getItem(LEGACY) && age > 2 * 864e5
  } catch { return true }
}

export function markOnboardingDone(user) {
  try {
    localStorage.setItem(LEGACY, '1')
    if (user?.id) localStorage.setItem(key(user.id), '1')
  } catch { /* sin almacenamiento */ }
}
